// export var apiBasePath = 'https://resources.touchnet.it';
export var apiBasePath = 'https://resources.touchnet.it';
export var apikey = '73f04f44-ce40-4450-a3ae-af96f7a1cefa'; // volpe
export var theme = 'default';


export var htmlPathAdsList = '../../themes/'+ theme + '/html/tnadslist.component.html'

// '9a520557-521d-41e1-aad1-f08a7761988b'; // Il mondo
// 'b6f097f5-9a06-41d6-85f8-4ca0958b48b7'; // Delta Immobiliare
// '73f04f44-ce40-4450-a3ae-af96f7a1cefa'; // Volpe immobiliare 
// '75f84593-8cd6-4bdd-9777-dddaa675b4a3'; // immobili e turismo 
// '00d73c2d-b811-47fa-8f57-b4515c5ff953'; // House Service
// '8da83ed3-5a95-495b-a8ec-168ed133a06b';
// '289ddef1-d444-4e55-814a-155de6d33c58'; // case e aste
// '2a78d12a-9715-4615-b4d6-82ac71f87bac'; // eureka


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/global.ts